import { PropType, defineComponent, onUnmounted, reactive, onMounted, watch } from 'vue'
import { useRoute } from 'vue-router'
import Tracker from '@nio-fe/nio-tracker-web'
import HomeSearchInput, { HomeSearchInputProps } from '../searchList'
import styles from './styles.module.scss'
import { Store } from 'pinia'
import {
  ComponentActions,
  ComponentState,
  useComponentStore,
} from '../../nsh5/localStores/component'
import { useAppStore } from '../../stores/app'
import { SearchPoint } from '../../contract/searchPoint'
import { clearHistory } from '../../router'

export default defineComponent({
  name: 'handle-box',
  emits: ['handleFilter', 'hideFilter', 'showFilterPopupView'],
  components: {},
  props: {
    componentStore: {
      // 用于同一项目功能模块间的通信
      type: Object as PropType<Store<string, ComponentState, {}, ComponentActions>>,
      default: null,
    },
  },
  setup: (props) => {
    // 获取组件配置
    const componentsConfig: any = window.NSComponentsConfig
    const appStore = useAppStore()
    const componentStore = useComponentStore()

    const state = reactive({
      input: false,
    })
    const handleSelect: HomeSearchInputProps['onSelect'] = (poiResource) => {
      props.componentStore.searchListPanel && props.componentStore.bus.emit('closeSearchListPanel')
      componentStore.$patch({
        searchListPanel: false,
      }) // 关闭搜索看板
      const [lng, lat] = poiResource.location.split(',').map((val) => Number(val))
      componentStore.$patch({
        tempSearchPoiResource: {
          lng,
          lat,
          name: poiResource.name,
          pointType: poiResource.pointType,
          pointSubType: poiResource.pointSubType,
          id: poiResource.id,
          address: poiResource.address,
        } as SearchPoint,
      })
      componentStore.bus.emit('searchPoiResource', {
        lng,
        lat,
        name: poiResource.name,
        pointType: poiResource.pointType,
        pointSubType: poiResource.pointSubType,
        id: poiResource.id,
        address: poiResource.address,
      })
    }

    const handleSearchIconClick = () => {
      componentStore.tempSearchPoiResource !== null &&
        componentStore.bus.emit('searchPoiResource', componentStore.tempSearchPoiResource)
    }

    const handleFocus: HomeSearchInputProps['onFocus'] = () => {
      state.input = true
      clearHistory()
      // 搜索点击埋点
      Tracker.track('nsh5_citymapclicksearch', appStore.trackParamsCommon)
    }

    const handleBlur: HomeSearchInputProps['onBlur'] = () => {
      state.input = false
    }

    /**
     * 清除
     */
    const handleClearSearchInput = () => {
      // 还原input状态
      state.input = false
    }

    onUnmounted(() => {
      // componentStore.bus.off('handleClearSearchInput')
    })

    onMounted(() => {
      componentStore.$patch({ showSearchBackGround: false })
    })

    const clickContent = () => {
      componentStore.$patch({ showSearchPanel: false, showHandleBox: true })
    }
    // watch(() => route.name, (val) => {
    //   if (val === 'pin' || val === 'resource') {
    //     componentStore.$patch({ showSearchBackGround: false, showHandleBox: false })
    //   }
    // })

    return () => {
      return componentsConfig && componentsConfig.search.show ? (
        <>
          <div
            class={[
              styles.searchListContainer,
              componentStore.showSearchBackGround ? styles.searchBackground : '',
            ]}
          >
            <div class={styles.searchInput}>
              <HomeSearchInput
                className={styles.input}
                // modelValue={componentStore.tempSearchPoiResource?.name} // 20240912 选择搜索列表不回填到搜索框
                modelValue={componentStore.searchKeywordInMobile}
                placeholder="搜索"
                onSelect={handleSelect}
                onFocus={handleFocus}
                onSearchIconClick={handleSearchIconClick}
                onBlur={handleBlur}
                onClear={handleClearSearchInput}
              />
            </div>
          </div>
          <div
            class={styles.searchListContent}
            onClick={clickContent}
            onTouchstart={clickContent}
            onMousemove={clickContent}
          ></div>
        </>
      ) : null
    }
  },
})
